import { UI_LOCALES } from '../countries/types';
import { normaliseUiLocale } from '../countries/formatting';
export { UI_LOCALES, normaliseUiLocale };
export const SOURCE_LOCALE = 'en';
export function localeDirection(locale) {
    return normaliseUiLocale(locale) === 'ar' ? 'rtl' : 'ltr';
}
export const CORE_NAMESPACES = ['common', 'shell', 'auth', 'errors', 'validation', 'settings'];
export const API_NAMESPACES = ['common', 'errors', 'validation', 'enum', 'print', 'notifications', 'patients', 'portal', 'queue'];
export const MODULE_NAMESPACES = ['admin', 'billing', 'opd', 'pharmacy', 'lab', 'radiology', 'ipd', 'server'];
export const ALL_NAMESPACES = [
    'common',
    'shell',
    'auth',
    'errors',
    'validation',
    'enum',
    'print',
    'notifications',
    'settings',
    'patients',
    'portal',
    'queue',
    ...MODULE_NAMESPACES,
];
export const RELEASED_LOCALES = {
    en: true,
    ar: false,
    es: false,
    'ur-Latn': false,
};
export function resolveUiLocale(input) {
    const allowed = new Set(['en', ...input.allowed]);
    for (const candidate of [input.userLocale, input.tenantLocale, input.countryDefault]) {
        if (!candidate)
            continue;
        const locale = normaliseUiLocale(candidate);
        if (allowed.has(locale))
            return locale;
    }
    return 'en';
}
//# sourceMappingURL=locales.js.map